import React from "react";
import { Table } from "semantic-ui-react";
import "../../styles/ui.scss";

interface IBCFixedText {
  fixedClass?: string;
  text: string;
}

const BCFixedText = ({ ...props }: IBCFixedText) => {
  return (
    <Table className={`fixed-header ${props.fixedClass}`} fixed celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell singleLine>{props.text}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    </Table>
  );
};

export default BCFixedText;
